import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas'; // 추가
import { Header, Button, Pie, ChartsHeader } from '../components';
import {
  AgentName, dropdownDataFontSize, dropdownDataReviewPeriodStart, dropdownDataReviewPeriodEnd,
  ecomPieChartData, sentimentPieData, intentTypeData, intentPieData, sentimentTotalPieData, intentDetailTypeData, intentDetailPieData, intentTypeDataOnlyFour
} from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import AgentComment from '../components/AgentComment';
import Dropdown from '../components/Dropdown';
import DataPreview from '../components/DataPreview';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';

import LineEDAreviewTrend from './Charts/LineEDAreviewTrend';
import LineEDAratingTrend from './Charts/LineEDAratingTrend';
import LineAItotalTrend from './Charts/LineAItotalTrend';
import axios from 'axios';
import Swal from 'sweetalert2';
import AgentCommentMaster from '../components/AgentCommentMaster';

import { useLocation, useNavigate } from "react-router-dom";

const AImodeling = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUrl = window.location.href;
  let nextPage = "";

  // const [isRequestSent, setIsRequestSent] = React.useState(false);

  // 각 AI 유형에 따라 요청 보냄 상태 관리
  const [isRequestSent_sentiment, setIsRequestSent_sentiment] = useState(false);
  const [isRequestSent_intent, setIsRequestSent_intent] = useState(false);
  const [isRequestSent_total, setIsRequestSent_total] = useState(false);

  const [lambdaResult_sentiment, setLambdaResult_sentiment] = React.useState("인사이트 분석시작 버튼을 누르면 데이터 분석을 도와드려요!");
  const [lambdaResult_intent, setLambdaResult_intent] = React.useState("인사이트 분석시작 버튼을 누르면 데이터 분석을 도와드려요!");
  const [lambdaResult_total, setLambdaResult_total] = React.useState("인사이트 분석시작 버튼을 누르면 데이터 분석을 도와드려요!");

  const { currentColor, currentMode } = useStateContext();
  // 현재 표시할 팔레트
  const [showPalette, setShowPalette] = useState(null);
  const [selectedColors, setSelectedColors] = useState(null);
  const [chartFontSize, setChartFontSize] = useState('12px'); // 글자 크기 상태 관리
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  let previewType = "raw";

  let btnName = "";
  let navLink = "";

  let AItype = "";
  let pageTitle = "";
  let AItypeName = "";

  const handleDataDownload = (AItypeName) => {

    let filePath = "";
    let fileName = "";
    // 다운로드할 파일의 경로 설정

    if (AItypeName == '감정분류') {
      filePath = '/data/dataset_classified_sentiment.csv'; // 예: public/data/sample-file.txt
      fileName = 'dataset_classified_sentiment.csv'; // 다운로드될 파일 이름
    } else if (AItypeName == '토픽분류') {
      filePath = '/data/dataset_classified_intent.csv'; // 예: public/data/sample-file.txt
      fileName = 'dataset_classified_intent.csv'; // 다운로드될 파일 이름
    } else if (AItypeName == '통합분류') {
      filePath = '/data/dataset_classified_total.csv'; // 예: public/data/sample-file.txt
      fileName = 'dataset_classified_total.csv'; // 다운로드될 파일 이름
    }


    // a 태그를 생성하여 클릭 이벤트를 트리거
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const downloadChartAsImage = async (chartId, fileName) => {
    const chartElement = document.getElementById(chartId); // 캡처할 차트의 DOM 요소
    if (!chartElement) {
      console.error(`Element with ID ${chartId} not found`);
      return;
    }

    try {
      const canvas = await html2canvas(chartElement, { scale: 2 }); // 캔버스로 렌더링
      const link = document.createElement('a');
      link.download = `${fileName}.png`; // 파일 이름
      link.href = canvas.toDataURL('image/png'); // 캡처된 이미지를 PNG로 변환
      link.click(); // 다운로드 실행
    } catch (error) {
      console.error('Error capturing chart:', error);
    }
  };


  // 감정분류or토픽분류에 따라 데이터셋 다르게 부여
  if (currentUrl.includes('cls/sentiment')) {
    AItype = "classifiedSentiment";
    AItypeName = "감정분류";
    previewType = "classifiedSentiment";
    nextPage = '/cls/intent/modeling'

  } else if (currentUrl.includes('cls/intent')) {
    AItype = "classifiedIntent";
    AItypeName = "토픽분류"
    previewType = "classifiedIntent";
    nextPage = '/cls/total/result'

  } else if (currentUrl.includes('cls/total')) {
    AItype = "classifiedTotal";
    AItypeName = "통합분류"
    nextPage = '/vis/preprocess';

  } else if (currentUrl.includes('cls/total/result/')) {
    AItype = "classifiedTotal";
    AItypeName = "통합분류"
    nextPage = '/vis/preprocess';
  }

  const [selectedSentimentColors, setSelectedSentimentColors] = useState({
    positive: '#0000FF', // 초기 긍정 색상 (파란색)
    neutral: 'grey', // 초기 중립 색상
    negative: '#FF0000', // 초기 부정 색상 (빨간색)
  });

  const [selectedIntentColors, setSelectedIntentColors] = useState({
    intent1: '#00A86B',      // Jungle Green
    intent2: '#DAA520',      // Goldenrod
    intent3: '#FF8C00',        // Dark Orange
    intent4: '#9932CC', // Dark Orchid
    intent5: '#4682B4',           // Steel Blue
  });

  const [selectedIntentDetailColors, setSelectedIntentDetailColors] = useState([
    {
      intentDetail1: '#66D1AB',
      intentDetail2: '#007A4C',
      intentDetail3: '#009E65'
    },

    {
      intentDetail1: '#FFD566',
      intentDetail2: '#007A4C',
      intentDetail3: '#E6B800'
    },


    {
      intentDetail1: '#FFB84D',
      intentDetail2: '#CC6E00',
      intentDetail3: '#FF7000'
    },


    {
      intentDetail1: '#C278E6',
      intentDetail2: '#731FA3',
      intentDetail3: '#AA00FF'
    },

    {
      intentDetail1: '#4682B4',
    },
  ]);

  const optionsPieSentiment = {
    labels: ['Positive', 'Negative', 'Neutral'],
    // colors: ['#0000FF', '#FF0000', 'grey'], // 원하는 색상 배열
    colors: [selectedSentimentColors.positive,
    selectedSentimentColors.negative,
    selectedSentimentColors.neutral
    ], // 원하는 색상 배열
    legend: {
      show: false,
    },
  };

  const handleNavBtn = () => {


    if (AItype == 'classifiedTotal') {
      btnName = '▶키워드시각화 하러가기';
      navLink = '/vis/preprocess';
    }

    else if (AItype == 'classifiedSentiment') {
      btnName = '▶토픽분류 하러가기';
      navLink = '/cls/intent/modeling';
    }

    else {
      btnName = '▶감정분류 하러가기';
      navLink = '/cls/sentiment/modeling';
    }

    return (
      <div>
        <Button
          color="white"
          bgColor={currentColor}
          text={btnName}
          borderRadius="10px"
          onClick={() => navigate(navLink)} />
      </div>
    )
  }


  // 모달 닫기 핸들러 (키보드 'Esc' 또는 바깥 클릭 시)
  useEffect(() => {

    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setShowPalette(null); // Esc 키로 모달 닫기
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown); // 이벤트 클린업
    window.location.reload();
    console.log(`chartFontSize: ${chartFontSize}`);
  }, [location.pathname, previewType]);

  // 사용자 색상 변경 핸들러
  const handleColorChange = (args, type) => {
    const chosenColor = args.currentValue.hex;
    if (type in selectedSentimentColors) {
      setSelectedSentimentColors((prevColors) => ({
        ...prevColors,
        [type]: chosenColor,
      }));
    } else if (type in selectedIntentColors) {
      setSelectedIntentColors((prevColors) => ({
        ...prevColors,
        [type]: chosenColor,
      }));
    }
  };

  // 팔레트 컴포넌트
  const CustomColorPicker = ({ id, mode, type }) => (
    <ColorPickerComponent
      id={id}
      mode={mode}
      modeSwitcher={false}
      inline
      showButtons={false}
      change={(args) => handleColorChange(args, type)}
    />
  );

  const showColorList = () => {
    if (AItype.includes('classifiedSentiment') | AItype.includes('classifiedTotal')) {
      return (
        <div className="flex gap-3 items-center">
          <p className="text-xl font-semibold">컬러변경</p>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">긍정</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedSentimentColors.positive }}
              onClick={() => setShowPalette('positive')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">중립</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedSentimentColors.neutral }}
              onClick={() => setShowPalette('neutral')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">부정</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedSentimentColors.negative }}
              onClick={() => setShowPalette('negative')}
            ></div>
          </div>
        </div>
      );
    } else if (AItype.includes('classifiedIntent')) {
      return (
        <div className="flex gap-3 items-center">
          <p className="text-xl font-semibold">컬러변경</p>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">{intentTypeData[0]}</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedIntentColors.intent1 }}
              onClick={() => setShowPalette('intent1')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">{intentTypeData[1]}</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedIntentColors.intent2 }}
              onClick={() => setShowPalette('intent2')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">{intentTypeData[2]}</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedIntentColors.intent3 }}
              onClick={() => setShowPalette('intent3')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">{intentTypeData[3]}</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedIntentColors.intent4 }}
              onClick={() => setShowPalette('intent4')}
            ></div>
          </div>
          <div className="flex items-center gap-2">
            <p className="text-s font-semibold">{intentTypeData[4]}</p>
            <div
              className="w-6 h-6 rounded-full cursor-pointer"
              style={{ backgroundColor: selectedIntentColors.intent5 }}
              onClick={() => setShowPalette('intent5')}
            ></div>
          </div>
        </div>
      );
    }
  };

  const showChart = () => {
    if (AItype.includes("classifiedSentiment")) {
      return (
        <div className="flex gap-4 items-stretch">
          <div className="flex-[3] bg-white p-4 rounded-lg">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold">긍부정 리뷰 구성비(%)</p>
              <Button
                color="white"
                bgColor={currentColor}
                text="다운로드(.png)"
                borderRadius="10px"
                onClick={() => downloadChartAsImage('pie-chart-container',
                  `긍부정 리뷰 구성비율`)} // 다운로드 핸들러
              />
            </div>
            <div id="pie-chart-container">
              <Pie
                key={JSON.stringify(selectedSentimentColors)} // 상태 변경 시 리렌더링 강제
                id="pie-chart"
                data={sentimentPieData}
                legendVisiblity={true}
                colors={[
                  selectedSentimentColors.positive,
                  selectedSentimentColors.negative,
                  selectedSentimentColors.neutral,
                ]}
                fontsize={chartFontSize}
              />
            </div>
          </div>

          <div className="flex-[7] bg-white p-4 rounded-lg">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold">긍부정 리뷰 Trend(건)</p>
              <Button
                color="white"
                bgColor={currentColor}
                text="다운로드(.png)"
                borderRadius="10px"
                onClick={() => downloadChartAsImage('line-chart-container',
                  '리뷰 토픽별 Trend 차트')} // 다운로드 핸들러
              />
            </div>
            <div id="line-chart-container">
              <LineEDAratingTrend
                AItype={AItype}
                colors={[
                  selectedSentimentColors.negative,
                  selectedSentimentColors.neutral,
                  selectedSentimentColors.positive,
                ]}
                fontsize={chartFontSize}
              />
            </div>
          </div>
          <hr className="my-8 border-gray-300" />
        </div>
      )
    }

    else if (AItype.includes("classifiedIntent")) {
      return (
        <div>

          <div className="flex gap-4 items-stretch">
            <div className="flex-[3] bg-white p-4 rounded-lg">
              <div className="flex items-center gap-4">
                <p className="text-xl font-semibold">리뷰 토픽별 구성비(%)</p>
                <Button
                  color="white"
                  bgColor={currentColor}
                  text="다운로드(.png)"
                  borderRadius="10px"
                  onClick={() => downloadChartAsImage('pie-chart-container',
                    `긍부정 리뷰 전체 구성비율`)} // 다운로드 핸들러
                />
              </div>
              <div id="pie-chart-container">
                <Pie
                  key={JSON.stringify(selectedIntentColors)} // 상태 변경 시 리렌더링 강제
                  id="pie-chart"
                  data={intentPieData}
                  legendVisiblity={true}
                  colors={[
                    selectedIntentColors.intent1,
                    selectedIntentColors.intent2,
                    selectedIntentColors.intent3,
                    selectedIntentColors.intent4,
                    selectedIntentColors.intent5,
                  ]}
                  fontsize={chartFontSize}
                />
              </div>
            </div>

            <div className="flex-[7] bg-white p-4 rounded-lg">
              <div className="flex items-center gap-4">
                <p className="text-xl font-semibold">리뷰 토픽별 Trend(건)</p>
                <Button
                  color="white"
                  bgColor={currentColor}
                  text="다운로드(.png)"
                  borderRadius="10px"
                  onClick={() => downloadChartAsImage('line-chart-container',
                    '리뷰 전체 토픽별 Trend')} // 다운로드 핸들러
                />
              </div>
              <div id="line-chart-container">
                <LineEDAratingTrend
                  AItype={AItype}
                  colors={[
                    selectedIntentColors.intent1,
                    selectedIntentColors.intent2,
                    selectedIntentColors.intent3,
                    selectedIntentColors.intent4,
                    selectedIntentColors.intent5,
                  ]}
                  fontsize={chartFontSize}
                  chartTpye="intent-overview"
                />
              </div>
            </div>

          </div>
          <hr className="my-8 border-gray-300" />

          {/* 상세분류결과 */}
          {intentTypeDataOnlyFour.map((intentName, index) => (
            <div>
              <p className="text-xl font-semibold">{intentName} 리뷰</p><br />
              {/* <div className="flex gap-3 items-center">
                

                <div className="flex items-center gap-2">
                  <p className="text-s font-semibold">{intentDetailTypeData[intentName][0]}</p>
                  <div
                    className="w-6 h-6 rounded-full cursor-pointer"
                    style={{ backgroundColor: selectedIntentDetailColors[index].intentDetail1 }}
                    onClick={() => setShowPalette('intentDetail1')}
                  ></div>
                </div>
                <div className="flex items-center gap-2">
                  <p className="text-s font-semibold">{intentDetailTypeData[intentName][1]}</p>
                  <div
                    className="w-6 h-6 rounded-full cursor-pointer"
                    style={{ backgroundColor: selectedIntentDetailColors[index].intentDetail2 }}
                    onClick={() => setShowPalette('intentDetail2')}
                  ></div>
                </div>
                <div className="flex items-center gap-2">
                  <p className="text-s font-semibold">{intentDetailTypeData[intentName][2]}</p>
                  <div
                    className="w-6 h-6 rounded-full cursor-pointer"
                    style={{ backgroundColor: selectedIntentDetailColors[index].intentDetail3 }}
                    onClick={() => setShowPalette('intentDetail3')}
                  ></div>
                </div>
              </div> */}
              <div className="flex gap-4 items-stretch">

                <div className="flex-[3] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">상세 토픽 구성비(%)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('pie-chart-container',
                        `${intentName}_상세토픽별 리뷰 구성비율`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="pie-chart-container">
                    <Pie
                      key={JSON.stringify(selectedSentimentColors)} // 상태 변경 시 리렌더링 강제
                      id={`pie-chart-${index}`}
                      data={intentDetailPieData[intentName]}
                      legendVisiblity={true}
                      colors={[
                        selectedIntentDetailColors[index].intentDetail1,
                        selectedIntentDetailColors[index].intentDetail2,
                        selectedIntentDetailColors[index].intentDetail3,
                      ]}
                      fontsize={chartFontSize}
                    />
                  </div>
                </div>

                <div className="flex-[7] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">상세 토픽별 Trend(건)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('line-chart-container',
                        `${intentName}상세토픽별 리뷰 Trend`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="line-chart-container">
                    <LineEDAratingTrend
                      id={`line-chart-${index}`}
                      AItype={AItype}
                      colors={[
                        selectedIntentDetailColors[index].intentDetail1,
                        selectedIntentDetailColors[index].intentDetail2,
                        selectedIntentDetailColors[index].intentDetail3,
                      ]}
                      fontsize={chartFontSize}
                      intent={intentName}
                      chartTpye="intent-detail"
                    />
                  </div>
                </div>
              </div>
              <hr className="my-8 border-gray-300" />
            </div>
          ))}

          <div>
            <p className="text-xl font-semibold">{intentTypeData[4]} 리뷰</p><br />
            <div className="flex gap-4 items-stretch">

              <div className="flex-[3] bg-white p-4 rounded-lg">
                <div className="flex items-center gap-4">
                  <p className="text-xl font-semibold">상세 토픽 구성비(%)</p>
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="다운로드(.png)"
                    borderRadius="10px"
                    onClick={() => downloadChartAsImage('pie-chart-container',
                      `${intentTypeData[4]}_상세토픽별 리뷰 구성비율`)} // 다운로드 핸들러
                  />
                </div>
                <div id="pie-chart-container">
                  <Pie
                    key={JSON.stringify(selectedSentimentColors)} // 상태 변경 시 리렌더링 강제
                    id={`pie-chart-spam`}
                    data={intentDetailPieData[intentTypeData[4]]}
                    legendVisiblity={true}
                    colors={[
                      selectedIntentDetailColors[4].intentDetail1,
                    ]}
                    fontsize={chartFontSize}
                  />
                </div>
              </div>

              <div className="flex-[7] bg-white p-4 rounded-lg">
                <div className="flex items-center gap-4">
                  <p className="text-xl font-semibold">상세 토픽별 Trend(건)</p>
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="다운로드(.png)"
                    borderRadius="10px"
                    onClick={() => downloadChartAsImage('line-chart-container',
                      `${intentTypeData[4]} 상세토픽별 리뷰 Trend`)} // 다운로드 핸들러
                  />
                </div>
                <div id="line-chart-container">
                  <LineEDAratingTrend
                    id={`line-chart-spam`}
                    AItype={AItype}
                    colors={[
                      selectedIntentDetailColors[4].intentDetail1,
                    ]}
                    fontsize={chartFontSize}
                    intent={intentTypeData[4]}
                    chartTpye="intent-detail-spam"
                  />
                </div>
              </div>
            </div>
            <hr className="my-8 border-gray-300" />
          </div>
        </div>
      )
    }


    else if (AItype.includes("classifiedTotal")) {
      return (
        <div>
          {intentTypeData.map((intentName, index) => (
            <div>
              <div className="flex gap-3 items-center">
                <p className="text-xl font-semibold">{intentName} 리뷰</p><br />
                <Button
                  color="white"
                  bgColor={currentColor}
                  text="상세조회하기"
                  borderRadius="10px"
                  onClick={() => navigate("/cls/total/result-detail",
                    { state: { intentName } })}
                />
              </div>
              <div className="flex gap-4 items-stretch">

                <div className="flex-[3] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">긍부정 리뷰 구성비(%)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('pie-chart-container',
                        `${intentName}_긍부정 리뷰 구성비율`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="pie-chart-container">
                    <Pie
                      key={JSON.stringify(selectedSentimentColors)} // 상태 변경 시 리렌더링 강제
                      id={`pie-chart-${index}`}
                      data={sentimentTotalPieData[intentName]}
                      legendVisiblity={true}
                      colors={[
                        selectedSentimentColors.positive,
                        selectedSentimentColors.negative,
                        selectedSentimentColors.neutral,
                      ]}
                      fontsize={chartFontSize}
                    />
                  </div>
                </div>

                <div className="flex-[7] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">긍부정 리뷰 Trend(건)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('line-chart-container',
                        `${intentName}_긍부정 리뷰 Trend 차트`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="line-chart-container">
                    <LineEDAratingTrend
                      id={`line-chart-${index}`}
                      AItype={AItype}
                      colors={[
                        selectedSentimentColors.negative,
                        selectedSentimentColors.neutral,
                        selectedSentimentColors.positive,
                      ]}
                      fontsize={chartFontSize}
                      intent={intentName}
                    />
                  </div>
                </div>
              </div>
              <hr className="my-8 border-gray-300" />
            </div>

          ))}
        </div>
      )
    }
  }

  const handleLambdaRequest = async () => {
    if (AItype === "classifiedSentiment" && isRequestSent_sentiment) return;
    if (AItype === "classifiedIntent" && isRequestSent_intent) return;
    if (AItype === "classifiedTotal" && isRequestSent_total) return;

    // 요청 상태 업데이트
    if (AItype === "classifiedSentiment") setIsRequestSent_sentiment(true);
    if (AItype === "classifiedIntent") setIsRequestSent_intent(true);
    if (AItype === "classifiedTotal") setIsRequestSent_total(true);

    const sentiment_percent = "긍정53%, 중립30% 부정 17%";
    const sentiment_review_trend = "1월:1-2점(168건),3점(32건),4-5점(158건), 2월:1-2점(88건),3점(23건),4-5점(96건), 3월:1-2점(133건),3점(46건),4-5점(144건), 4월:1-2점(186건),3점(45건),4-5점(150건), 5월:1-2점(147건),3점(42건),4-5점(139건), 6월:1-2점(122건),3점(40건),4-5점(166건), 7월:1-2점(231건),3점(38건),4-5점(131건), 8월:1-2점(183건),3점(40건),4-5점(140건), 9월:1-2점(161건),3점(38건),4-5점(148건), 10월:1-2점(194건),3점(56건),4-5점(134건)";
    const intent_percent = "39%, 18%, 15%, 23%, 3%";
    const intent_review_trend = "1월에 버그리포트 분류 리뷰가 많고, 7월에 기능 분류 리뷰가 많고, 9월에 가격/결제 관련 리뷰가 많음";
    const intent_sentiment = "대분류1.기능/UIUX (1-1.디자인관련,1-2.사용편의성,1-3.신규기능요청),대분류2.버그리포트(성능) (2-1.앱오류,2-2속도저하,2-3.연결 문제),대분류3.가격/결제/수수료/포인트(3-1.결제오류, 3-2.포인트/리워드,3-3.수수료관련),대분류4. 스팸+단순 감정 표현(4-1.단순긍부정,4-2.짧은소감,4-3.광고성댓글),대분류5. 1,2,3,4카테고리 제외 기타의견. /// 1-a:긍정20건,부정46건, 1-b:긍정220건,부정370건, 1-c:긍정159건,부정607건, 2-a:긍정5건,부정434건, 2-b:긍정2건,부정114건, 2-c:긍정1건,부정116건, 3-a:긍정5건,부정266건, 3-b:긍정43건,부정194건, 3-c:긍정8건,부정41건, 4-a:긍정179건,부정266건, 4-b:긍정186건,부정53건, 4-c:긍정6건,부정153건, 5:긍정37건,부정62건";

    try {
      let requestData;
      if (AItype === "classifiedSentiment") {
        requestData = {
          name: "llm_ai_2",
          sentiment_percent: sentiment_percent,
          sentiment_review_trend: sentiment_review_trend,
        };
      } else if (AItype === "classifiedIntent") {
        requestData = {
          name: "llm_ai_4",
          intent_percent: intent_percent,
          intent_review_trend: intent_review_trend,
        };
      } else if (AItype === "classifiedTotal") {
        requestData = {
          name: "llm_ai_5",
          intent_sentiment: intent_sentiment
        };
      }
      else {
        console.error("Invalid AItype value:", AItype);
        setLambdaResult_sentiment("AI 유형이 잘못되었습니다.");
        setLambdaResult_intent("AI 유형이 잘못되었습니다.");
        setLambdaResult_total("AI 유형이 잘못되었습니다.");
        return;
      }
      const response = await axios.post(
        "https://farqijyj9a.execute-api.ap-northeast-2.amazonaws.com/241113/agent",
        requestData
      );

      // 요청 데이터 출력
      console.log("요청 데이터:", requestData);

      // Lambda 응답 디코딩 및 처리
      const responseBody = JSON.parse(response.data.body); // `body`를 JSON으로 파싱
      console.log("Lambda 응답:", responseBody);

      // Lambda 결과값 반영
      if (AItype === "classifiedSentiment") {
        setLambdaResult_sentiment(responseBody.answer || "결과를 불러왔습니다.");
      } else if (AItype === "classifiedIntent") {
        setLambdaResult_intent(responseBody.answer || "결과를 불러왔습니다.");
      } else if (AItype === "classifiedTotal") {
        setLambdaResult_total(responseBody.answer || "결과를 불러왔습니다.");
      }
    } catch (error) {
      console.error("Lambda 호출 중 오류 발생:", error);
      setLambdaResult_sentiment("오류가 발생했습니다. 다시 시도해주세요.");
      setLambdaResult_intent("오류가 발생했습니다. 다시 시도해주세요.");
      setLambdaResult_total("오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      // 요청 상태 초기화 (성공/실패 관계 없이 재시도 불가)
      if (AItype === "classifiedSentiment") setIsRequestSent_sentiment(true);
      if (AItype === "classifiedIntent") setIsRequestSent_intent(true);
      if (AItype === "classifiedTotal") setIsRequestSent_total(true);
    }
  };

  return (
    <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
      <Header category={`AI ${AItypeName} 분류`} title="분류결과 조회" />
      <AgentComment
        title={AgentName}
        comment={
          AItype === "classifiedSentiment"
            ? "토스 앱 리뷰의 감정 분류와 월별 리뷰 트렌드 차트를 분석해 사용자 만족도 변화를 파악해요. 긍정과 부정 비율을 통해 특정 기간의 변동 요인을 찾아보고, 부정 리뷰에서는 문제점을, 긍정 리뷰에서는 강점을 추출해요. 이를 바탕으로 기능별 개선과 트렌드 예측으로 서비스 전략을 강화할 수 있어요."
            : AItype === "classifiedIntent"
              ? "토스 앱 리뷰의 토픽 분류 결과를 분석해 사용자 관심사를 파악해요. 각 토픽의 비율을 살펴 주요 니즈를 확인하고, 오류는 우선 해결하고 기능 요청은 유사 항목을 묶어 개발 계획에 반영해요. 기간별 토픽 변화도 분석해 서비스 개선에 활용할 수 있어요."
              : AItype === "classifiedTotal"
                ? "앞선 두 AI 분류의 통합 결과를 보여드릴게요! 정확히는 토스 앱 리뷰의 토픽별 감정의 구성비를 보여드려요. 어떤 토픽에서 긍정 또는 부정이 도출되었는지 확인하고 개선 인사이트를 도출해볼수 있어요."
                : "데이터 유형이 올바르지 않습니다. 다시 확인해주세요."
        } /><br />
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        <Header title="분류결과" />

        <div className="flex gap-3 items-center">
          <p className="text-s font-semibold">조회기간</p>
          <p className="text-s">시작일</p>
          <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodStart} />
          <p className="text-s">종료일</p>
          <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodEnd} />


          <Button
            color="white"
            bgColor={currentColor}
            text="분류결과 다운로드(.xlsx)"
            borderRadius="10px"
            onClick={() => handleDataDownload(AItypeName)}
          />
        </div>
        <DataPreview previewType={previewType} />
      </div>

      {/* 차트 디자인 편집 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg">
      <Header title="그래프 시각화" />

        <div className="flex gap-4 items-center">

          {showColorList()}
          {/* 팔레트 모달 */}
          {showPalette && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
              onClick={() => setShowPalette(null)} // 바깥 클릭 시 모달 닫기
            >
              <div
                className="bg-white p-5 rounded-lg shadow-lg"
                onClick={(e) => e.stopPropagation()} // 모달 내부 클릭 시 이벤트 전파 방지
              >
                <CustomColorPicker id="inline-palette" mode="Palette" type={showPalette} />
                <div className="flex justify-center mt-4">
                  <button
                    onClick={() => setShowPalette(null)}
                    className="px-4 py-2 rounded-lg"
                    style={{
                      backgroundColor: 'rgb(90, 198, 213)',
                      color: 'white',
                    }}
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="flex items-center gap-2">
            <p className="text-xl font-semibold">글자크기</p>
            <Dropdown currentMode={currentMode}
              dropdownData={dropdownDataFontSize}
              selectedValue={chartFontSize} // 상태 전달
              onChange={(selectedValue) => setChartFontSize(selectedValue)} // 선택된 값 저장
            />
          </div>
        </div>

        <hr className="my-8 border-gray-300" />

        {showChart()}

        <br/><br/><br/>

        <button
          onClick={async () => {
            console.log("Button clicked!"); // 클릭 시 콘솔 출력

            const swalInstance = Swal.fire({
              title: '인사이트 분석 시작',
              html: '새로고침하지 마시고 잠시만 기다려주세요.<br>최대 1분까지 소요될 수 있어요.',
              icon: 'info',
              timer: 60000, // 1분 타이머 설정
              allowOutsideClick: false, // 팝업 밖 클릭 비활성화
              allowEscapeKey: false,    // ESC 키 비활성화
              allowEnterKey: false,     // 엔터 키 비활성화
              timerProgressBar: true,   // 타이머 진행 바 표시
              didOpen: () => {
                Swal.showLoading();     // 팝업 로딩 애니메이션 표시
              },
            });

            try {
              const response = await handleLambdaRequest(); // Lambda 요청 실행
              console.log('Response received:', response);

              // 요청 성공 시 팝업 닫기
              Swal.close();
              Swal.fire({
                title: '분석 완료',
                html: '데몽이의 분석 가이드를 확인해 보세요 :)',
                icon: 'success',
                confirmButtonText: '확인',
                confirmButtonColor: currentColor,
              });
            } catch (error) {
              console.error('Error during request:', error);

              // 요청 실패 시 에러 팝업 표시
              Swal.close();
              Swal.fire({
                title: '분석 실패',
                html: '요청을 처리하는 중 오류가 발생했습니다.<br>다시 시도해주세요.',
                icon: 'error',
                confirmButtonText: '확인',
                confirmButtonColor: currentColor,
              });
            }
          }}
          style={{
            backgroundColor: currentColor, // 배경색
            color: 'white',                // 텍스트 색상
            borderRadius: '10px',          // 모서리 둥글게
            padding: '12px 24px',          // 버튼 패딩
            fontSize: '16px',              // 폰트 크기
            cursor: 'pointer',             // 마우스 커서
            border: 'none',                // 테두리 제거
            transition: 'background-color 0.3s', // 배경색 변화에 트랜지션 추가
          }}
          className="hover:bg-gray-700 hover:drop-shadow-xl" // 호버 시 효과 추가
        >
          인사이트 분석시작
        </button>

        <AgentCommentMaster
          title={AItype === "classifiedSentiment" ? "데몽이의 감정 분석 결과" : AItype === "classifiedIntent" ? " 데몽이의 토픽 분석 결과" : " 데몽이의 전체 분석 결과"}
          comment={
            AItype === "classifiedSentiment"
              ? lambdaResult_sentiment
              : AItype === "classifiedIntent"
                ? lambdaResult_intent
                : lambdaResult_total
          }
        />


        <div className="flex justify-end">
          <Button
            color="white"
            bgColor={currentColor}
            text={AItype == 'classifiedTotal' ? '▶데이터 시각화 하러가기' :
              AItype == 'classifiedSentiment' ? '▶AI 토픽분류 하러가기' : '▶통합분류 결과조회 하러가기'}
            borderRadius="10px"
            onClick={()=>navigate(nextPage)}
          />

          {/* {handleNavBtn()} */}
        </div>
      </div>
    </div >
  );
};

export default AImodeling;
